// Centralizamos para usar en los modales y en la vista
export const COMPONENTES_MAXIMOS = [
    { cod: "D", label: "Departamento" },
    { cod: "I", label: "División" },
    { cod: "U", label: "Unidad" },
];

export const labelComponenteMaximo = (cod) =>
    COMPONENTES_MAXIMOS.find((c) => c.cod === cod)?.label ?? "";
